export const defaultConfig = () => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': 'en',
    },
  };
  return config;
};
